import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS, FormGroup } from 'src/app/common';
import { AppConstants } from 'src/app/common/constants';
import { IPermission, IRole, IUser } from 'src/app/models';
import { AlertService, BlockUiHandlerService, PermissionService, StorageService, UserService } from 'src/app/services';
import { RoleService } from 'src/app/services/role.service';

@Component({
  selector: 'app-users-assigns',
  templateUrl: './users-assigns.component.html',
  styleUrls: ['./users-assigns.component.css']
})
export class UsersAssignsComponent implements OnInit {
  //VARBOX

  constructor() { }

  ngOnInit(): void {

  }

}
